<template>
    <div>
        <div><i class="material-icons">delete</i><i class="material-icons">published_with_changes</i></div>
        <h3>Send til nytt verksted:</h3>

        <div class="inputWrap">
            <v-select placeholder="Verksted" v-model="workshop" label="select_value" :options="workshops"></v-select>
            <span class="v-error" v-if="localErrors.workshop" v-text="localErrors.workshop"></span>
        </div>

        <div>
            <button @click.prevent="close()">Avbryt</button>

            <button @click.prevent="deleteRequest()">Kanseller</button>

            <button @click.prevent="changeWorkshop()">Send</button>
        </div>

    </div>
</template>

<script>

import VuejsDialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js'; // only needed in custom components
//import workshops from '../../../mixins/workshops.js';

export default {
  data () {
    return {
        id_workshop_current: null,
        id_workshop: null,
        workshops: [],
        validate: false
    }
  },
  mixins: [VuejsDialogMixin],

  computed: {
      workshop: {
          get: function () {
              for (var i = 0; i < this.workshops.length; i++) {
                  var workshop = this.workshops[i];
                  if(workshop.id == this.id_workshop)
                      return workshop
              }
              return null
          },
          set: function (workshop) {
              if(workshop)
                this.id_workshop = workshop.id
              else
                this.id_workshop = null
          }
      },
      localErrors(){
          if(this.validate){
              var e = {};
              if(!this.workshop) {
                  e.workshop = 'Please select workshop';
              }else if(this.id_workshop == this.id_workshop_current){
                  e.workshop = 'Please change workshop';
              }
              return e;
          }else{
              return {};
          }
      }
  },
  methods: {
      changeWorkshop(){
        this.validate = true;
        if(!this.validateChanges()) return;
        this.proceed({
            id_workshop: this.id_workshop
        });
      },
      deleteRequest(){
          this.proceed({
              visibility: 0
          });
      },
      validateChanges(){
          this.validate = true;

          if(Object.keys(this.localErrors).length)
              return false;

          return true;
      },
  },
  created(){
      this.workshops = this.$options.propsData.options.workshops;
      this.id_workshop_current = this.$options.propsData.options.id_workshop;
      this.id_workshop = this.$options.propsData.options.id_workshop;
  }
}
</script>

<style lang="scss">
    .v-error{
        color: red;
        text-align: right;
        font-size: 12px;
    }
</style>


// WEBPACK FOOTER //
// DeleteDialog.vue?c0e0b71e